import { render, staticRenderFns } from "./comment-list-toolbar.vue?vue&type=template&id=08d13f24&"
import script from "./comment-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./comment-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports